module.exports = __webpack_public_path__ + "static/media/21.5eee5dda.gif";